import config from "../config/config";
import { getToken } from "../utils/prefix"


  export async function aboutus_create(data) {
    const res = await fetch(config.api_backend + `/setting/about/create`, {
      body: JSON.stringify(data),
      method: "POST",
      headers: {
        // "x-access-token": getToken(),
        "Content-type": "application/json",
      },
    });
  
    const dataRespone = await res.json();
    return dataRespone;
  }


  export async function aboutus_get(data) {
    const res = await fetch(config.api_backend + `/setting/about/get`, {
      body: JSON.stringify(data),
      method: "POST",
      headers: {
        // Authorization: getToken(),
        "Content-type": "application/json",
      },
    });
  
    const dataRespone = await res.json();
    return dataRespone;
  }
  

  export async function contactus_create(data) {
    const res = await fetch(config.api_backend + `/setting/contact/create`, {
      body: JSON.stringify(data),
      method: "POST",
      headers: {
        // Authorization: getToken(),
        "Content-type": "application/json",
      },
    });
  
    const dataRespone = await res.json();
    return dataRespone;
  }


  export async function contactus_get(data) {
    const res = await fetch(config.api_backend + `/setting/contact/get`, {
      body: JSON.stringify(data),
      method: "POST",
      headers: {
        // Authorization: getToken(),
        "Content-type": "application/json",
      },
    });
  
    const dataRespone = await res.json();
    return dataRespone;
  }


//   export async function news_update(data) {
//     const res = await fetch(config.api_backend + `/news/update`, {
//       body: JSON.stringify(data),
//       method: "POST",
//       headers: {
//       //   Authorization: getToken(),
//         "Content-type": "application/json",
//       },
//     });
  
//     const dataRespone = await res.json();
//     return dataRespone;
//   }
  
//   export async function news_delete(data) {
//     const res = await fetch(config.api_backend + `/news/delete`, {
//       body: JSON.stringify(data),
//       method: "POST",
//       headers: {
//       //   Authorization: getToken(),
//         "Content-type": "application/json",
//       },
//     });
  
//     const dataRespone = await res.json();
//     return dataRespone;
//   }
  
//   export async function get_all_news(data) {
//     const res = await fetch(config.api_backend + `/news/all`, {
//       body: JSON.stringify(data),
//       method: "POST",
//       headers: {
//         // Authorization: getToken(),
//         "Content-type": "application/json",
//       },
//     });
  
//     const dataRespone = await res.json();
//     return dataRespone;
//   }

//   export async function get_active_news(data) {
//     const res = await fetch(config.api_backend + `/news/get`, {
//       body: JSON.stringify(data),
//       method: "POST",
//       headers: {
//         // Authorization: getToken(),
//         "Content-type": "application/json",
//       },
//     });
  
//     const dataRespone = await res.json();
//     return dataRespone;
//   }

//   export async function get_suggest_news(data) {
//     const res = await fetch(config.api_backend + `/news/suggestion`, {
//       body: JSON.stringify(data),
//       method: "POST",
//       headers: {
//         // Authorization: getToken(),
//         "Content-type": "application/json",
//       },
//     });
  
//     const dataRespone = await res.json();
//     return dataRespone;
//   }

//   export async function get_news(data) {
//     const res = await fetch(config.api_backend + `/news/getNewsById`, {
//       body: JSON.stringify(data),
//       method: "POST",
//       headers: {
//       //   Authorization: getToken(),
//         "Content-type": "application/json",
//       },
//     });
  
//     const dataRespone = await res.json();
//     return dataRespone;
//   }

//   export async function news_update_status(data) {
//     const res = await fetch(config.api_backend + `/news/updateStatus`, {
//       body: JSON.stringify(data),
//       method: "POST",
//       headers: {
//       //   Authorization: getToken(),
//         "Content-type": "application/json",
//       },
//     });
  
//     const dataRespone = await res.json();
//     return dataRespone;
//   }

  export async function save_about_img(data) {
    var formdata = new FormData();
    formdata.append('news_id', data.news_id);
    formdata.append('user_id', data.user_id);
    formdata.append('file', data.file);
    const res = await fetch(config.api_backend + `/news/uploadNewsImgFile`, {
      body: formdata,
      method: "POST",
      headers: {
      "x-access-token": getToken(),

      },
    });
  
    const dataRespone = await res.json();
    return dataRespone;
  }
 